import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useAuth } from "../Login/AuthContext";

const FavoritosContext = createContext();

const obtenerClave = (usuario) =>
  usuario ? `casa-arte:favoritos:${usuario.id || usuario.username}` : null;

export const FavoritosProvider = ({ children }) => {
  const { usuario, cargando } = useAuth();
  const [favoritos, setFavoritos] = useState([]);
  const clave = useMemo(() => obtenerClave(usuario), [usuario]);

  useEffect(() => {
    if (cargando) return;
    if (!clave || usuario?.rol !== "cliente") {
      setFavoritos([]);
      return;
    }

    try {
      const guardados = JSON.parse(window.localStorage.getItem(clave) || "[]");
      setFavoritos(Array.isArray(guardados) ? guardados : []);
    } catch {
      setFavoritos([]);
    }
  }, [cargando, clave, usuario?.rol]);

  const guardar = (nuevosFavoritos) => {
    setFavoritos(nuevosFavoritos);
    if (clave) {
      window.localStorage.setItem(clave, JSON.stringify(nuevosFavoritos));
    }
  };

  const esFavorito = (productoId) =>
    favoritos.some((producto) => String(producto.id) === String(productoId));

  const alternarFavorito = (producto) => {
    if (!producto?.id) return false;

    if (esFavorito(producto.id)) {
      guardar(
        favoritos.filter(
          (favorito) => String(favorito.id) !== String(producto.id)
        )
      );
      return false;
    }

    guardar([...favoritos, producto]);
    return true;
  };

  const eliminarFavorito = (productoId) => {
    guardar(
      favoritos.filter(
        (producto) => String(producto.id) !== String(productoId)
      )
    );
  };

  return (
    <FavoritosContext.Provider
      value={{
        favoritos,
        cantidadFavoritos: favoritos.length,
        esFavorito,
        alternarFavorito,
        eliminarFavorito,
      }}
    >
      {children}
    </FavoritosContext.Provider>
  );
};

export const useFavoritos = () => useContext(FavoritosContext);

